import React, { useContext, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { SelectionMode } from '@fluentui/react';
import { ContextualDetailsList, GridContext, GridContextProvider } from '@bingads-webui-grid/grid-context';
import { useCampaignGridDataSource } from '@bingads-webui-grid/campaign-data-source';

import { getAssetGroupsEDM } from '../model/asset-group';

const AssetGroupColumn = i18n => ({
  key: 'AssetGroup',
  name: i18n.getString(_TL_('Asset group')),
  fieldName: 'AssetGroupName',
  className: 'column-asset-group',
  headerClassName: 'header-asset-group',
  minWidth: 120,
  maxWidth: 200,
  sortable: false,
  isMultiline: false,
  isResizable: true,
});

const CampaignColumn = i18n => ({
  key: 'Campaign',
  name: i18n.getString(_TL_('Campaign')),
  fieldName: 'CampaignName',
  className: 'column-campaign',
  headerClassName: 'header-campaign',
  minWidth: 120,
  maxWidth: 200,
  sortable: false,
  isMultiline: false,
  isResizable: true,
});

const Grid = ({
  i18n,
  cid,
  aid,
  audienceGroupId,
  onGenericError,
}) => {
  const { dispatch } = useContext(GridContext);

  useCampaignGridDataSource({
    edm: getAssetGroupsEDM({ cid, aid, audienceGroupId }),
    odataParams: {
      query: {
        select: undefined,
      },
    },
    onError: onGenericError,
  });

  useEffect(() => {
    const columns = [AssetGroupColumn(i18n), CampaignColumn(i18n)];
    dispatch({ type: 'UPDATE_SELECTED_COLUMNS', payload: columns });
  }, [dispatch, i18n]);

  return (
    <ContextualDetailsList
      availablePageSizes={[5]}
      setKey="asset-groups-grid"
      stickyHeader
    />
  );
};

Grid.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  aid: PropTypes.number.isRequired,
  cid: PropTypes.number.isRequired,
  audienceGroupId: PropTypes.number.isRequired,
  onGenericError: PropTypes.func,
};

Grid.defaultProps = {
  onGenericError: null,
};

export const AssetGroupsGrid = (props) => {
  const initialGridContext = useMemo(() => ({
    selectionMode: SelectionMode.none,
    pagination: {
      pageSize: 5,
    },
  }), []);

  return (
    <div className="asset-groups-grid">
      <GridContextProvider {...initialGridContext}>
        <Grid {...props} />
      </GridContextProvider>
    </div>
  );
};
